// extracted by mini-css-extract-plugin
export default {"refundContainer":"refund_refundContainer__xfwog"};